const getLatestVerification = (verificationMap) => {
  if (!verificationMap || Object.keys(verificationMap).length === 0) return {};
  
  const sortedKeys = Object.keys(verificationMap).sort((a, b) => {
    const numA = parseInt(a.split('_')[1]);
    const numB = parseInt(b.split('_')[1]);
    return numA - numB;
  });

  return verificationMap[sortedKeys[sortedKeys.length - 1]];
};

export default getLatestVerification;
